// Copyright (c) 2016 Deere & Company

import t from 'tcomb';
import trim from 'lodash/trim';

const TimestampUser = t.struct({
    firstName: t.String,
    id: t.String,
    lastName: t.String
}, {
    name: 'TimestampUser',
    strict: true
});

TimestampUser.prototype.buildUserName = function buildUserName() {

    const name = trim(`${this.firstName} ${this.lastName}`, ' ');

    return trim(`${name} - ${this.id}`, ' -');

};

export const getDefaultState = () => new TimestampUser({
    firstName: '',
    id: '',
    lastName: ''
});

export default TimestampUser;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/timestamp-user.js